// frontend/src/pages/storeActivity/EngagementPanel.jsx
//
// Did anyone open the app, and when: one column per day of the window,
// page views and actions stacked, with the three numbers that summarise it.
// Scheduled work is excluded upstream (api/views/analytics.py::_engagement)
// — a nightly job is not a merchant.
//
// Zero days are drawn as empty slots, not skipped: the gaps are what this
// chart is read for.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ICON, ChartBar } from '../../icons';
import { useFormatters } from '../../hooks/useFormatters';
import { relativeTime } from '../../utils/relativeTime';
import { DailyBars, Panel, Stat } from './primitives';

export default function EngagementPanel({ engagement }) {
  const { t } = useTranslation();
  const { formatNumber, formatDateTime } = useFormatters();
  const { days, window_days: windowDays, active_days: activeDays, sessions, last_seen: lastSeen } = engagement;

  const quiet = days.every((d) => d.views + d.actions === 0);

  return (
    <Panel
      icon={<ChartBar size={ICON.md} />}
      title={t('storeActivity.engagement.title')}
      subtitle={t('storeActivity.engagement.subtitle', { count: windowDays })}
    >
      <div className="sa-stats">
        <Stat
          value={formatNumber(activeDays, 0)}
          label={t('storeActivity.engagement.activeDays')}
          note={t('storeActivity.engagement.ofDays', { count: windowDays })}
        />
        <Stat value={formatNumber(sessions, 0)} label={t('storeActivity.engagement.sessions')} />
        <Stat
          value={lastSeen ? relativeTime(lastSeen, t) : t('storeActivity.lifecycle.never')}
          label={t('storeActivity.engagement.lastSeen')}
          note={lastSeen ? formatDateTime(lastSeen) : null}
        />
      </div>

      {quiet
        ? <div className="sa-panel-empty">{t('storeActivity.engagement.none', { count: windowDays })}</div>
        : (
          <DailyBars
            days={days}
            label={t('storeActivity.engagement.title')}
            series={[
              { key: 'actions', label: t('storeActivity.engagement.actions'), modifier: 'actions' },
              { key: 'views', label: t('storeActivity.engagement.views'), modifier: 'views' },
            ]}
          />
        )}
    </Panel>
  );
}
